import { Component } from 'react'
import { API } from 'aws-amplify'
//import { v4 as uuidv4 } from 'uuid'
import config from './Config'

const apiPath = config.apiGatewayEnergy.PATH

class EnergyClient extends Component {
	getCompanies() {
		return API.post(apiPath, 'companies/list', {})
	}

	addCompany(companyId, name, url, active, billingAccount, billingPeriod, billingMethod, billingEmail, vatRate, counties) {
        const data = {
			companyId,
			name,
			url,
			active,
			billingAccount,
			billingPeriod,
			billingMethod,
            billingEmail,
			vatRate,
			counties
		}
		console.log(data)

        return API.post(apiPath, 'companies/add', {
            body: data
        })
    }

    updateCompany(companyId, url, active, billingAccount, billingPeriod, billingMethod, billingEmail, vatRate, counties, productsAvailable) {
        const data = {
			companyId,
			url,
			active,
			billingAccount,
			billingPeriod,
			billingMethod,
			billingEmail,
			vatRate,
			counties,
			productsAvailable
		}
		console.log(data)

        return API.post(apiPath, 'companies/update', {
            body: data
        })
    }

	getCompanyDetails(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/get', {
			body: data
		})
	}

	getDeliveries() {
		return API.post(apiPath, 'deliveries/list', {})
	}
	
	getSfDeliveries() {
		return API.post(apiPath, 'deliveries/list-sf', {})
	}

	addDelivery(companyId, companyName, product, leadPrice, webhook, weight, active) {
		const data = {
			companyId,
			companyName,
			product,
			leadPrice,
			webhook,
			weight,
			active
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/add', {
            body: data
        })
	}

	addSfDelivery(companyId, companyName, product, leadPrice, webhook, weight, weeklyCap, active) {
		const data = {
			companyId,
			companyName,
			product,
			leadPrice,
			webhook,
			weight,
			weeklyCap,
			active
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/add-sf', {
            body: data
        })
	}

	updateDelivery(companyId, product, leadPrice, webhook, weight, active) {
		const data = {
			companyId,
			product,
			leadPrice,
			webhook,
			weight,
			active
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update', {
            body: data
        })
	}

	updateSfDelivery(companyId, product, leadPrice, webhook, weight, weeklyCap, active) {
		const data = {
			companyId,
			product,
			leadPrice,
			webhook,
			weight,
			weeklyCap,
			active
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update-sf', {
            body: data
        })
	}

	updateEeDeliveries(deliveries) {
		const data = {
			deliveries
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update-ee-deliveries', {
            body: data
        })
	}

	updateSfDeliveries(deliveries) {
		const data = {
			deliveries
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update-sf-deliveries', {
            body: data
        })
	}

	getLeads() {
		return API.post(apiPath, 'leads/list-all', {})
	}

	getEeLeadsPeriod(product, fromDate, toDate) {
		const data = {
			product,
			fromDate,
			toDate
		}
		console.log(data)
		return API.post(apiPath, 'leads/list-ee-period', {
			body: data
		})
	}

	getSfLeads() {
		return API.post(apiPath, 'leads/list-sf', {})
	}

	getSfLeadsPeriod(product, fromDate, toDate) {
		const data = {
			product,
			fromDate,
			toDate
		}
		console.log(data)
		return API.post(apiPath, 'leads/list-sf-period', {
			body: data
		})
	}

	getLead(date, leadId, site) {
		const data = {
			date,
			leadId,
			site
		}
		return API.post(apiPath, 'leads/get', {
			body: data
		})
	}

	allocateLead(companyId, lead, site) {
		const data = {
			companyId,
			lead,
			site
		}
		console.log(data)

        return API.post(apiPath, 'leads/allocate', {
            body: data
        })
	}

	rejectLead(site, date, leadId) {
		const data = {
			site,
			date,
			leadId
		}
		console.log(data)

        return API.post(apiPath, 'leads/reject', {
            body: data
        })
	}

	updateLeadDetails(date, leadId, details, site) {
		const data = {
			date,
			leadId,
			details,
			site
		}
		console.log(data)

		return API.post(apiPath, 'leads/update-details', {
			body: data
		})
	}

	getPayments() {
		return API.post(apiPath, 'payments/list', {})
	}

	addPayment(companyId, companyName, date, billingMethod, billingAccount, billingPeriod, vatRate, allocation, subtotal, total, status, notes) {
		const data = {
			companyId,
			companyName,
			date,
			billingMethod,
			billingAccount,
			billingPeriod,
			vatRate,
			allocation, 
			subtotal, 
			total,
			status,
			notes
		}
		console.log(data)

        return API.post(apiPath, 'payments/add', {
            body: data
        })
	}

	updatePayment(companyId, date, billingAccount, vatRate, allocation, subtotal, total, status, notes, reference, amountPaid) {
		const data = {
			companyId,
			date,
			billingAccount,
			vatRate,
			allocation, 
			subtotal, 
			total,
			status,
			notes,
			reference,
			amountPaid
		}
		console.log(data)

        return API.post(apiPath, 'payments/update', {
            body: data
        })
	}

	deletePayment(companyId, date) {
		const data = {
			companyId,
			date
		}
		console.log(data)

        return API.post(apiPath, 'payments/delete', {
            body: data
        })
	}

	getProfitabilityWeeks() {
		return API.post(apiPath, 'profitability/list', {})
	}

	addProfitabilityWeek(country, date, details, leads, revenue, cost, notes) {
		const data = {
			country,
			date,
			details,
			leads,
			revenue,
			cost, 
			notes
		}
		console.log('data: ', data)

        return API.post(apiPath, 'profitability/add', {
            body: data
        })
	}

	updateProfitabilityWeek(country, date, details, leads, revenue, cost, notes) {
		const data = {
			country,
			date,
			details,
			leads,
			revenue,
			cost, 
			notes
		}
		console.log(data)

        return API.post(apiPath, 'profitability/update', {
            body: data
        })
	}

	deleteProfitabilityWeek(country, date) {
		const data = {
			country,
			date
		}
		console.log(data)

        return API.post(apiPath, 'profitability/delete', {
            body: data
        })
	}

	generateInvoice(payment) {
		const data = {
			payment
		}
		console.log(data)

		return API.post(apiPath, 'payments/generate-invoice', {
			body: data
		})
	}

	retryCharge(payment) {
		const data = {
			payment
		}
		console.log(data)

		return API.post(apiPath, 'payments/retry-charge', {
			body: data
		})
	}

	getBalanceDeliveries() {
		return API.post(apiPath, 'deliveries/list-balance', {})
	}

	// ==========================================
	// Energy Deliveries (bd-energy-deliveries)
	// ==========================================

	getEnergyDeliveries() {
		return API.post(apiPath, 'deliveries/list-energy', {})
	}

	addEnergyDelivery(companyId, companyName, product, leadPrice, webhook, deliveryEmail, solarStackWebhook, privyrWebhook, weeklyCap, active, minEELeads, eeLeadMode, priority, surgeEnabled, surgePercent, weekendLeads, businessHoursOnly, hkCommission, preHkLeads, billingCompanyId, sourceOverrides, rejectDuplicates) {
		const data = {
			companyId,
			companyName,
			product,
			leadPrice,
			webhook,
			deliveryEmail,
			solarStackWebhook,
			privyrWebhook,
			weeklyCap,
			active,
			minEELeads,
			eeLeadMode,
			priority,
			surgeEnabled,
			surgePercent,
			weekendLeads,
			businessHoursOnly,
			hkCommission,
			preHkLeads,
			billingCompanyId,
			sourceOverrides: sourceOverrides || null,
			rejectDuplicates: rejectDuplicates === true
		}
		console.log(data)

		return API.post(apiPath, 'deliveries/add-energy', {
			body: data
		})
	}

	updateEnergyDelivery(companyId, product, leadPrice, webhook, deliveryEmail, solarStackWebhook, privyrWebhook, weeklyCap, active, minEELeads, eeLeadMode, priority, surgeEnabled, surgePercent, weekendLeads, businessHoursOnly, hkCommission, preHkLeads, billingMode, billingCompanyId, sourceOverrides, rejectDuplicates, capEffective) {
		const data = {
			companyId,
			product,
			leadPrice,
			webhook,
			deliveryEmail,
			solarStackWebhook,
			privyrWebhook,
			weeklyCap,
			active,
			minEELeads,
			eeLeadMode,
			priority,
			surgeEnabled,
			surgePercent,
			weekendLeads,
			businessHoursOnly,
			hkCommission,
			preHkLeads,
			billingMode,
			billingCompanyId,
			sourceOverrides: sourceOverrides || null,
			rejectDuplicates: rejectDuplicates === true,
			capEffective: (capEffective === 'next' || capEffective === 'cancel') ? capEffective : 'now'
		}
		console.log(data)

		return API.post(apiPath, 'deliveries/update-energy', {
			body: data
		})
	}

	getEnergyAnalytics(product) {
		return API.post(apiPath, 'deliveries/energy-analytics', {
			body: { product }
		})
	}

	getHKCommissionSummary(from, to) {
		return API.post(apiPath, 'payments/hk-commission-summary', {
			body: { from, to }
		})
	}

	setHKWeekPaid(weekEnding, paid) {
		return API.post(apiPath, 'payments/hk-set-week-paid', {
			body: { weekEnding, paid }
		})
	}

	testEmailDelivery(companyId, product, deliveryEmail, lead) {
		return API.post(apiPath, 'deliveries/test-email-delivery', {
			body: { companyId, product, deliveryEmail, lead }
		})
	}

	testWebhookDelivery(webhook, product, site, payload) {
		return API.post(apiPath, 'deliveries/test-webhook-delivery', {
			body: { webhook, product, site, payload }
		})
	}

	testSolarStackDelivery(solarStackWebhook, payload) {
		return API.post(apiPath, 'deliveries/test-solarstack-delivery', {
			body: { solarStackWebhook, payload }
		})
	}

	testPrivyrDelivery(privyrWebhook, payload) {
		return API.post(apiPath, 'deliveries/test-privyr-delivery', {
			body: { privyrWebhook, payload }
		})
	}

	rerunEnergyTargets(product = 'Solar') {
		return API.post(apiPath, 'deliveries/rerun-energy-targets', {
			body: { product }
		})
	}

	rerunMarketingActions(product = 'Solar') {
		return API.post(apiPath, 'deliveries/rerun-marketing-actions', {
			body: { product }
		})
	}

	sendMarketingSlack(product = 'Solar') {
		return API.post(apiPath, 'deliveries/send-marketing-slack', {
			body: { product }
		})
	}
}

export default EnergyClient